import React from 'react';
import { ContentParagraph } from '../../../_lib/components/ContentParagraph';
import { Strong } from '../../../components/atoms/Strong/Strong';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { PagePublicationInfoText } from '../../../_lib/components/PagePublicationInfo/partials/PagePublicationInfoText';

type ProposedPagePublicationInfoText = {
  hasNoPublicationPrivileges: boolean;
};

export function ProposedPagePublicationInfoText({ hasNoPublicationPrivileges }: ProposedPagePublicationInfoText) {
  const { t } = useSonTranslation('ProposedPagePublicationInfo');
  return (
    <PagePublicationInfoText>
      <ContentParagraph>
        {t(`entryText`)}
        {/* keep empty space here */}
        {!hasNoPublicationPrivileges && <Strong> {t(`entryQuestion`)}</Strong>}
      </ContentParagraph>
    </PagePublicationInfoText>
  );
}
